var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewHeightInside3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "169px",
    height: "214px",
    viewBox: "0 0 450 570",
    enableBackground: "new 0 0 450 570",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 84.9,
    y: 116.9,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 280.2,
    height: 389
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 140,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 234,
    height: 342.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.989,
    x1: 140.1,
    y1: 468.5,
    x2: 140.1,
    y2: 153.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "149.1,465.8 140.1,481.3 131.2,465.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "149.1,156.5 140.1,141 131.2,156.5  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.989,
    x1: 225,
    y1: 468.5,
    x2: 225,
    y2: 153.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "233.9,465.8 225,481.3 216.1,465.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "233.9,156.5 225,141 216.1,156.5  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.989,
    x1: 308.5,
    y1: 468.5,
    x2: 308.5,
    y2: 153.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "317.4,465.8 308.5,481.3 299.5,465.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "317.4,156.5 308.5,141 299.5,156.5  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M132.5,84.1l6.5-16h2.5l6.4,16h-2.3l-1.4-3.6h-8l-1.4,3.6H132.5z M136.8,78.8h6.8l-3.4-8.6L136.8,78.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M219.3,84.1v-16h7.1c1.4,0,2.5,0.4,3.3,1.1c0.8,0.8,1.2,1.7,1.2,2.9c0,1-0.3,1.8-0.8,2.4s-1.2,1.1-2,1.2 c0.8,0.1,1.6,0.6,2.2,1.4c0.6,0.8,0.9,1.6,0.9,2.6c0,1.3-0.4,2.4-1.2,3.1c-0.8,0.8-2,1.2-3.4,1.2H219.3z M221.3,75h4.8 c0.9,0,1.6-0.2,2-0.7c0.5-0.5,0.7-1.1,0.7-1.8c0-0.7-0.2-1.4-0.7-1.9s-1.2-0.7-2-0.7h-4.8V75z M221.3,82.3h4.9 c0.9,0,1.6-0.2,2.2-0.7s0.8-1.2,0.8-2c0-0.8-0.3-1.4-0.8-2s-1.2-0.8-2.2-0.8h-4.9V82.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M302.2,79.5c-0.4-1-0.6-2.2-0.6-3.4s0.2-2.3,0.6-3.4s1-1.9,1.7-2.6s1.6-1.3,2.6-1.7s2.1-0.6,3.2-0.6 c2.6,0,4.6,1.1,6.1,3.2l-1.7,0.9c-0.5-0.7-1.1-1.3-1.9-1.7s-1.6-0.6-2.5-0.6c-1.8,0-3.2,0.6-4.4,1.8s-1.8,2.8-1.8,4.7 c0,1.2,0.3,2.4,0.8,3.4s1.3,1.8,2.2,2.3s2,0.8,3.1,0.8c0.9,0,1.7-0.2,2.5-0.6s1.4-1,1.9-1.7l1.7,0.9c-1.6,2.1-3.6,3.2-6.1,3.2 c-1.1,0-2.2-0.2-3.2-0.6s-1.9-1-2.6-1.7S302.7,80.5,302.2,79.5z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewHeightInside3);
export default __webpack_public_path__ + "static/media/new_height_inside_3.c1bedbdcc65188c84bd4989e1d60f471.svg";
export { ForwardRef as ReactComponent };